import { Faq } from './../../models/Faq';
import { createReducer, on } from '@ngrx/store';
import {
  getAllFaqsSuccess,
  addFaqSuccess,
  updateFaqSuccess,
  deleteFaqSuccess
} from './faq.actions';

export interface FaqState {
  faqs: Faq[];
}

export const initialState: FaqState = {
  faqs: [],
};

export const faqReducer = createReducer(
  initialState,
  on(getAllFaqsSuccess, (state, { faqs }) => ({
    ...state,
    faqs
  })),
  on(addFaqSuccess, (state, { faq }) => ({
    ...state,
    faqs: [...state.faqs, faq]
  })),
  on(updateFaqSuccess, (state, { faq }) => ({
    ...state,
    faqs: state.faqs.map(f => f.id === faq.id ? faq : f)
  })),
  on(deleteFaqSuccess, (state, { id }) => ({
    ...state,
    faqs: state.faqs.filter(f => f.id !== id)
  }))
);
